const GET_AZURE_METRICS_RESPONSE = "GET_AZURE_METRICS_RESPONSE";
const GET_AZURE_METRICS_RESPONSE_SUCCESS = "GET_AZURE_METRICS_RESPONSE_SUCCESS";
const GET_AZURE_METRICS_RESPONSE_ERROR = "GET_AZURE_METRICS_RESPONSE_ERROR";

export {
  GET_AZURE_METRICS_RESPONSE,
  GET_AZURE_METRICS_RESPONSE_SUCCESS,
  GET_AZURE_METRICS_RESPONSE_ERROR,
};
